import React, { useState, useEffect, useContext } from "react";
import useForm from '../banner/customHooks';
import { X_TENANT_ID, THEME_URL } from '../../common/ActionUrl'
import axios from 'axios';
import { AuthContext } from "../../common/Auth"
import WhoWeAreDayForm from './WhoWeAreDayForm';
import { _useToasts } from "../../common/_useToasts";
import { USERTYPES } from "../../constant/userType";

const WhoWeAre = ({ aboutId, handleClose, fromEditAction }) => {

	const { user, userType, getThemeSettings } = useContext(AuthContext)

	const { inputs, handleInputChange, handleSubmit, handleColorPicker, handleCheckboxInputChange, resetColor, errors } = useForm({ title: "", titleFont: "", titleFontSize: "", titleColor: "", subTitle: "", subTitleFont: "", subTitleFontSize: "", subTitleColor: "", discription: "", discriptionFont: "", discriptionFontSize: "", discriptionColor: "", paddingTop: "", paddingBottom: "", marginTop: "", marginBottom: "", marginRight: "", marginLeft: "", paddingRight: "", paddingLeft: "", fullSection: false }, "", updateAboutCallback);

	const { _addToast } = _useToasts();
	const [aboutData, setAboutData] = useState({})
	const [isLoading, setIsLoading] = useState(false)
	const userId = user?.userId


	async function updateAboutCallback() {

		let insertData = {
			"values": {
				"title": inputs.title,
				"titleFont": inputs.titleFont,
				"titleFontSize": inputs.titleFontSize,
				"subTitle": inputs.subTitle,
				"subTitleFont": inputs.subTitleFont,
				"subTitleFontSize": inputs.subTitleFontSize,
				"titleColor": inputs.titleColor,
				"subTitleColor": inputs.subTitleColor,
				"discription": inputs.discription,
				"discriptionFont": inputs.discriptionFont,
				"discriptionFontSize": inputs.discriptionFontSize,
				"discriptionColor": inputs.discriptionColor,
				"paddingTop": inputs.paddingTop,
				"paddingBottom": inputs.paddingBottom,
				"marginTop": inputs.marginTop,
				"marginBottom": inputs.marginBottom,
				"marginRight": inputs.marginRight,
				"marginLeft": inputs.marginLeft,
				"paddingRight": inputs.paddingRight,
				"paddingLeft": inputs.paddingLeft,
				"fullSection": inputs.fullSection

			},
			"settingsName": "whoWeAre",
			userId
		}
		const requestOptions = {
			headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID }
		};
		setIsLoading(true)
		if (aboutId) {
			axios.patch(THEME_URL + aboutId, insertData, requestOptions)
				.then(res => {
					setIsLoading(false)
					if (res.data.error) {
						_addToast(res.data.message, {
							appearance: "error",
							autoDismiss: true
						});
					} else {
						getThemeSettings()
						handleClose()
					}
				}).catch(err => {
					console.log('err', err);
				});
		} else {
			axios.post(THEME_URL, insertData, requestOptions)
				.then(res => {
					setIsLoading(false)
					if (res.data.error) {
						_addToast(res.data.message, {
							appearance: "error",
							autoDismiss: true
						});
					} else {
						getThemeSettings()
						handleClose()
					}
				}).catch(err => {
					console.log('err', err);
				});
		}
	}
	const getAbout = () => {
		setIsLoading(true)
		const requestOptions = {
			headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID },
		};
		axios.get(THEME_URL + aboutId, requestOptions)
			.then(res => {
				setIsLoading(false)
				if (res.data.error) {
					_addToast(res.data.message, {
						appearance: "error",
						autoDismiss: true
					});
				} else {
					if (res.data.settingsName === "whoWeAre") {
						setAboutData(res.data.values[0])
					}
				}
			})
			.catch(err => {
				console.log('err', err);
			});
	}

	useEffect(() => {
		if (aboutId) {
			getAbout()
		}
	}, [aboutId])

	//its a temp value for update inputs value when edit banner
	const [value, setValue] = useState(0);
	useEffect(() => {
		if (Object.keys(aboutData).length > 0) {
			inputs.title = aboutData.title
			inputs.titleFont = aboutData.titleFont
			inputs.titleFontSize = aboutData.titleFontSize
			inputs.titleColor = aboutData.titleColor
			inputs.subTitle = aboutData.subTitle
			inputs.subTitleFont = aboutData.subTitleFont
			inputs.subTitleFontSize = aboutData.subTitleFontSize
			inputs.subTitleColor = aboutData.subTitleColor
			inputs.discription = aboutData.discription
			inputs.discriptionFont = aboutData.discriptionFont
			inputs.discriptionFontSize = aboutData.discriptionFontSize
			inputs.discriptionColor = aboutData.discriptionColor
			inputs.paddingTop = aboutData.paddingTop
			inputs.paddingBottom = aboutData.paddingBottom
			inputs.marginTop = aboutData.marginTop
			inputs.marginBottom = aboutData.marginBottom
			inputs.marginRight = aboutData.marginRight
			inputs.marginLeft = aboutData.marginLeft
			inputs.paddingRight = aboutData.paddingRight
			inputs.paddingLeft = aboutData.paddingLeft
			inputs.fullSection = aboutData.fullSection
			setValue(value => value + 1);
		}
	}, [aboutData])


	return (
		<>
			<div className="contact-area pt-10 pb-10">
				{userType !== USERTYPES.USER ?
					<>
						<WhoWeAreDayForm
							isLoading={isLoading}
							inputs={inputs}
							handleSubmit={handleSubmit}
							handleInputChange={handleInputChange} errors={errors}
							handleColorPicker={handleColorPicker}
							aboutId={aboutId}
							handleClose={handleClose}
							fromEditAction={fromEditAction}
							handleCheckboxInputChange={handleCheckboxInputChange}
							resetColor={resetColor}
						/>
					</> : <h2>You haven't authority for update deal of the day settings</h2>}
			</div>
		</>
	);
};

export default WhoWeAre;
